import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';
import { ToastProvider } from '@gbv/ui';
import { router } from './routes';
import { ApiRequestError } from './lib/api';
import './index.css';

/**
 * The client portal is opened on a shop-floor phone over 4G. Cache windows are
 * longer here than in the employee portal because the data changes far less
 * often, and every avoided request is a second the owner does not wait.
 */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 2 * 60_000,
      gcTime: 10 * 60_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        if (error instanceof ApiRequestError && error.status < 500) return false;
        return failureCount < 2;
      },
    },
    mutations: { retry: false },
  },
});

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element is missing from index.html.');

createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <RouterProvider router={router} />
      </ToastProvider>
    </QueryClientProvider>
  </StrictMode>,
);
